document.querySelectorAll(".rte").forEach((container) => {
  const html = container.innerHTML;

  const updatedHTML = html
    .replace(/\[product_grid handles="(.*?)"\]/g, (_, handles) => {
      const handleList = handles.split(",");
      return `<div class="custom-product-grid" data-handles='${JSON.stringify(handleList)}'></div>`;
    })
    .replace(/\[product_slider handles="(.*?)"\]/g, (_, handles) => {
      const handleList = handles.split(",");
      return `<div class="custom-product-slider swiper" data-handles='${JSON.stringify(handleList)}'><div class="swiper-wrapper"></div></div>`;
    });

  container.innerHTML = updatedHTML;
});

// Loop over both grids and sliders
document.querySelectorAll(".custom-product-grid, .custom-product-slider").forEach(async (container) => {
  const isSlider = container.classList.contains("custom-product-slider");
  const handles = JSON.parse(container.dataset.handles || "[]");
  const wrapper = isSlider ? container.querySelector(".swiper-wrapper") : container;

  const products = await Promise.all(handles.map(async (handle) => {
    try {
      const res = await fetch(`/products/${handle.trim()}.js`);
      if (!res.ok) throw new Error(`404 for ${handle}`);
      return await res.json();
    } catch (err) {
      console.warn("❌ Failed to fetch product:", handle, err);
      return null;
    }
  }));

  const html = products
    .filter(Boolean)
    .map(product => {
      const content = `
        <div class="product-card" style="border: 1px solid #ddd; padding: 10px; text-align: center; margin: 8px; max-width: 350px;">
          <a href="${product.url}" style="text-decoration: none; color: inherit;">
            <img src="${product.images[0]}" alt="${product.title}" style="width: auto; height:250px; border-radius: 18px; margin-block: 20px;" />
            <h3 style="font-size: 18px; margin: 10px 0;">${product.title}</h3>
            <p style="font-weight: bold;">${(product.price / 100).toLocaleString('vi-VN')}₫</p>

          </a>
        </div>`;

      return isSlider
        ? `<div class="swiper-slide">${content}</div>`
        : content;
    }).join("");

  if (isSlider) {
    wrapper.innerHTML = html;

    // Insert arrows
    container.insertAdjacentHTML('beforeend', `
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    `);

    // Initialize Swiper here (inside the same scope)
if (typeof Swiper !== "undefined") {
const productCount = products.filter(Boolean).length;
const isFewSlides = productCount <= 2;

const swiper = new Swiper(container, {
  slidesPerView: isFewSlides ? 'auto' : 2,   // ⭐ KEY FIX
  spaceBetween: 10,

  centeredSlides: isFewSlides,
  allowTouchMove: !isFewSlides,
  watchOverflow: true,

  breakpoints: {
    414: {
      slidesPerView: 'auto',
      centeredSlides: productCount <= 1,
      allowTouchMove: productCount > 1
    },
    768: {
      slidesPerView: productCount <= 2 ? 'auto' : 2,
      centeredSlides: productCount <= 2,
      allowTouchMove: productCount > 2
    },
    1024: {
      slidesPerView: productCount <= 2 ? 'auto' : 3,
      centeredSlides: productCount <= 2,
      allowTouchMove: productCount > 2
    }
  },

  navigation: {
    nextEl: container.querySelector('.swiper-button-next'),
    prevEl: container.querySelector('.swiper-button-prev'),
  },

  on: {
    init(sw) {
      if (isFewSlides) {
      container.classList.add('few-slides');

      //  reset transform do Swiper set
      sw.wrapperEl.style.transform = 'translate3d(0,0,0)';

      // Ẩn arrow
      container
        .querySelectorAll('.swiper-button-prev, .swiper-button-next')
        .forEach(btn => btn.style.display = 'none');
      }
    }
  }
});


} else {
  console.warn("⚠️ Swiper not loaded yet.");
}

  } else {
    wrapper.innerHTML = `<div class="product-grid" style="display: flex; gap: 16px; flex-wrap: wrap;">${html}</div>`;
  }
});
